module.exports = __webpack_public_path__ + "img/Network03small.d56d365a.png";